<template>
  <div style="height: 100%">
    <el-row style="height: 40%;width: 100%">
      <label style="padding: 20px 0 0 30px;">上月WUE值</label>
      <el-col :span="24" style="width: 100%;height: 100%;position: relative">
        <pue-gauge :data="pueValue" ref="PueGauge" style="height: 100%"></pue-gauge>
        <el-row
          style="text-align: center;font-size: 14px;position: absolute;left: 0;bottom: 8%;height: 10%;width: 100%">
          <el-col :span="12">总用水量：{{ power }} L</el-col>
          <el-col :span="12">IT设备能耗值：{{ itPower }} kw·h</el-col>
        </el-row>
      </el-col>
    </el-row>
    <el-row style="height: 60%;width: 100%">
      <el-row>
        <el-col :span="12">
          <label style="padding: 0 0 0 30px;">WUE变化趋势</label>
        </el-col>
        <el-col :span="12" style="text-align: center">动力辅助能耗值：{{ powerAssist }} kw·h</el-col>
      </el-row>
      <el-col :span="24" style="width: 100%;height: 100%;padding-left: 8%">
        <LineChartPue1 ref="LineChartPue1" v-if="lineData.time!==null"
                       :data="lineData"
                       :extend-data="lineExtentData"
                       style="height: 65%"></LineChartPue1>
        <no-data v-else></no-data>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import NoData from "@/components/NoData";
import pueGauge from "@/components/echarts/pueGauge";
import LineChartPue1 from "@/components/echarts/LineChartPue1"
import {getYearTrend, getLastMonthPue} from "@/network/ems-record.js"

export default {
  name: "RealValuePue",
  components: {
    pueGauge, LineChartPue1, NoData
  },
  data() {
    return {
      date: [],//日期选择
      extendData: null,
      lineData: {
        time: null,
        value: null
      },
      lineExtentData: {'xAxis': [{'axisLabel': {'rotate': 45}}]},
      pueValue: 0,
      itPower: 0,
      power: 0
    };
  },
  computed: {
    powerAssist() {
      return (this.power - this.itPower).toFixed(1)
    }
  },
  mounted() {
    this.dateChange();
    this.getRealTimePue()
  },
  methods: {
    dateChange() {
      this.getLineData();
    },
    // WUE变化趋势
    getLineData() {
      getYearTrend('water').then(res => {
        if (res.code === 0 && res.data !== null) {
          this.lineData=res.data
          this.lineData.time = res.data.months
          this.lineData.value = res.data.values
        }
      })
    },
    // WUE实时值
    getRealTimePue() {
      getLastMonthPue('water').then(res => {
        if (res.code === 0 && res.data.pueValue !== null) {
          console.log(res)
          this.pueValue = res.data.pueValue
          this.itPower = res.data.itPower
          this.power = res.data.power
        }
      })
    }
  }
}
</script>

<style scoped>

label {
  font-weight: bold;
  color: #01EFFD;
}

</style>
